export function formatFetchMeta(meta) {
	if (!meta) return null;
	const chars = meta.chars != null ? Number(meta.chars).toLocaleString() : null;
	const durationSec =
		meta.duration_ms != null ? (Number(meta.duration_ms) / 1000).toFixed(1) : null;

	if (meta.error) {
		return { error: meta.error, chars, durationSec };
	}

	if (chars != null && durationSec != null) {
		return { label: `${chars} HTML chars • ${durationSec}s`, chars, durationSec };
	}

	return null;
}

export function getFetchMeta(fetchMeta, key) {
	if (!fetchMeta || typeof fetchMeta !== "object") return null;
	return fetchMeta[key] ?? null;
}
